import { LEDGER_ENTRY_TYPE } from 'Data/payments.js'

export function getNotes(entry) {
  switch (entry.type) {
    case LEDGER_ENTRY_TYPE.CHARGE:
    case LEDGER_ENTRY_TYPE.ADJUSTMENT:
      return entry.transactions.filter(t => !!t.notes)
    default:
      return entry.transaction?.notes ? [entry.transaction] : []
  }
}
